import { FooterSection, StyledIcon } from './designcss/footercss'

const Footer = () => {
  return (
    <FooterSection>
      <div className="footercontainer">
        <div className="icon-row">
          <StyledIcon href="https://web.facebook.com/albiemer" className="fa fa-facebook" />
          <StyledIcon href="https://gitlab.com/albiemerporte/" className="fa fa-gitlab" />
          {/*<StyledIcon href="https://github.com/albiemer" className="fa fa-github"> */}
          <StyledIcon href="https://www.linkedin.com/in/albiemer-porte/" className="fa fa-linkedin" />
          <StyledIcon href="https://www.youtube.com/@albiemer" className="fa fa-youtube" />
        </div>
        <p>&copy; 2024-2026 All rights reserved</p>
      </div>
    </FooterSection>
  );
};

export default Footer;
